import React from "react";

import $ from "quantdom";

function General() {
  return (
    <section className="general">
      <div className="loader-area animate__animated">
        <div className="load">
          <div className="loader"></div>
        </div>
      </div>
    </section>
  );
}

$().docReady(function() {
  $(".loader-area").addClass("animate__fadeOut");
  $(".loader-area").addClass("d-none");
});

window.addEventListener("scroll", function() {
  let position = window.pageYOffset;
  if (position > 20) {
    $("nav.navbar").addClass("stick");
  } else {
    $("nav.navbar").removeClass("stick");
  }
});


export default General;
